export default "__VITE_ASSET__1d8d3d41__"